import React from 'react';

import { useState } from 'react';
import { useEffect } from 'react';

import { Form } from 'react-bootstrap';
import { FormGroup } from 'react-bootstrap';
import { FormLabel } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

import AuthorStore from '../../../stores/AuthorStore';
import ResourceStore from '../../../stores/ResourceStore';
import SubjectMatterCategoryStore from '../../../stores/SubjectMatterCategoryStore';
import SchoolTypeStore from '../../../stores/SchoolTypeStore';

const SelectEntityPopup = (props) => {
    const [selectedEntity, setSelectedEntity] = useState(null);

    let portalResource = props.portalResource;

    const portalResourceStore = ResourceStore((state) => state);

    let wrapper = null;
    switch (props.entityType) {
        case 'authors':
            const authorStore = AuthorStore((state) => state);

            wrapper = {
                getHumanFriendlyLabel: () => {
                    return 'an Author';
                },

                loadFunction: () => {
                    authorStore.loadAllForSelectList();
                },

                getCurrentEntityList: () => {
                    return null == portalResource.authors
                        ? []
                        : portalResource.authors;
                },

                getAvailableEntities() {
                    return authorStore.authors;
                },

                buildLabelForSelectOption(author) {
                    return (
                        author.lastName +
                        ', ' +
                        author.firstName +
                        ' (' +
                        author.id +
                        ')'
                    );
                },
            };
            break;

        case 'subjectMatterCategories':
            const subjectMatterCategoryStore = SubjectMatterCategoryStore(
                (state) => state,
            );

            wrapper = {
                getHumanFriendlyLabel: () => {
                    return 'a Subject Matter Category';
                },

                loadFunction: () => {
                    subjectMatterCategoryStore.loadAll();
                },

                getCurrentEntityList: () => {
                    return null == portalResource.subjectMatterCategories
                        ? []
                        : portalResource.subjectMatterCategories;
                },

                getAvailableEntities() {
                    return subjectMatterCategoryStore.subjectMatterCategorys;
                },

                buildLabelForSelectOption(subjectMatterCategory) {
                    return (
                        subjectMatterCategory.category +
                        ' (' +
                        subjectMatterCategory.id +
                        ')'
                    );
                },
            };
            break;
        case 'schoolTypes':
            const schoolTypeStore = SchoolTypeStore((state) => state);

            wrapper = {
                getHumanFriendlyLabel: () => {
                    return 'a School Type';
                },

                loadFunction: () => {
                    schoolTypeStore.loadAll();
                },

                getCurrentEntityList: () => {
                    return null == portalResource.schoolTypes
                        ? []
                        : portalResource.schoolTypes;
                },

                getAvailableEntities() {
                    return schoolTypeStore.schoolTypes;
                },

                buildLabelForSelectOption(schoolType) {
                    return schoolType.name + ' (' + schoolType.id + ')';
                },
            };
            break;
        default:
        //noop
    }

    useEffect(wrapper.loadFunction, []);

    // Add logic to choose between authors,
    // subjectMatterCategories, and school Types
    let availableEntities = wrapper.getAvailableEntities();
    let currentEntityList = wrapper.getCurrentEntityList();

    if (null == availableEntities || 0 == availableEntities.length) {
        return <div>Loading ...</div>;
    }

    var entityId2Entities = {};
    for (let i = 0; i < availableEntities.length; i++) {
        entityId2Entities[availableEntities[i].id] = availableEntities[i];
    }

    let currentEntityIds = currentEntityList.map((entity, i) => {
        return entity.id.toString();
    });

    let chooseOption = (
        <option value={{ id: null }}>
            Choose {wrapper.getHumanFriendlyLabel()}
        </option>
    );
    let entityOptions = availableEntities.map((entity, i) => {
        let candidateEntityId = entity.id.toString();

        if (-1 == currentEntityIds.indexOf(candidateEntityId)) {
            return (
                <option value={entity.id}>
                    {wrapper.buildLabelForSelectOption(entity)}
                </option>
            );
        }
    });

    let selectOptionVals = [chooseOption].concat(entityOptions);

    return (
        <Modal
            show={true}
            onHide={() => {
                props.setIsSelectPopupVisible(false);
            }}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Choose {wrapper.getHumanFriendlyLabel()}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <FormGroup
                    style={{ marginTop: '8px' }}
                    key={'form-add-closed-set-element'}
                    controlId={'form-add-closed-set-element'}
                >
                    <FormLabel>
                        Please choose {wrapper.getHumanFriendlyLabel()} to add
                    </FormLabel>

                    <Form.Select
                        aria-label="Default select example"
                        onChange={(e) => {
                            let selectedEntityId = e.target.value;
                            let newEntity = entityId2Entities[selectedEntityId];

                            setSelectedEntity(newEntity);
                        }}
                    >
                        {selectOptionVals}
                    </Form.Select>
                </FormGroup>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={() => {
                        props.setIsSelectPopupVisible(false);
                    }}
                >
                    Close
                </Button>

                <Button
                    variant="primary"
                    onClick={() => {
                        var newEntities =
                            null == currentEntityList
                                ? []
                                : JSON.parse(JSON.stringify(currentEntityList));

                        newEntities.push(selectedEntity);

                        portalResourceStore.updateAttribute(
                            props.entityType,
                            newEntities,
                        );

                        props.setIsSelectPopupVisible(false);
                    }}
                >
                    Add
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SelectEntityPopup;
